class KeyboardEventHandler {
    constructor() {
        this.numKeys_ = 350;
        this.keyDown_ = [];
        this.keyPressed_ = [];

        for (let i = 0; i < this.numKeys_; i++) {
            this.keyDown_.push(false);
            this.keyPressed_.push(false);
        }
    }

    reset() {
        for (let i = 0; i < this.numKeys_; i++) {
            this.keyDown_[i] = false;
            this.keyPressed_[i] = false;
        }
    }

    keyDown(keyValue) {
        this.keyDown_[keyValue] = true;
    }

    keyUp(keyValue) {
        if(this.keyDown_[keyValue])
        {
            this.keyPressed_[keyValue] = true;
        }
        this.keyDown_[keyValue] = false;
    }

    isDown(key) {
        return this.keyDown_[key];
    }

    isPressed(key){
        const v = this.keyPressed_[key]; 
        this.keyPressed_[key] = false;
        return v;
    }
}

export { KeyboardEventHandler };
